export function convertToDateDomElementFormat(date) {
    // FIXME This check is needed because sometimes we manage dates as strings and other times as Date objects
    //  use always date objects
    if (typeof date === 'string') {
        return date;
    }
    return date.toISOString().substring(0,10)
}